import { getIn } from 'icepick';

export const isComplianceSnapshotMigrated = (state) => {
  return getIn(state, ['event', 'isComplianceSnapshotMigrated']);
};

export const getComplianceSettings = (state) => {
  return getIn(state, ['event', 'complianceSettings']);
};

export const getPrivacyPolicy = (state) => {
  return getComplianceSettings(state).privacyPolicy;
};

export const shouldShowPrivacyPolicy = (state) => {
  return getPrivacyPolicy(state).showPrivacyPolicy;
};

export const getPrivacyPolicyUrl = (state) => {
  return getPrivacyPolicy(state).privacyPolicyUrl || '';
};

export const getPrivacyPolicyLinkText = (state) => {
  return getPrivacyPolicy(state).privacyPolicyLinkText || '';
};

export const getCookieBannerSettings = (state) => {
  return getComplianceSettings(state).cookieBannerSettings;
};

export const shouldShowCookieBanner = (state) => {
  return getCookieBannerSettings(state).showCookieBanner;
};

export const shouldShowCookieBannerLink = (state) => {
  return getCookieBannerSettings(state).showCookieBannerLink;
};

export const getCventPrivacyPolicy = (state) => {
  return getComplianceSettings(state).cventPrivacyPolicy;
};

export const shouldShowCventPrivacyPolicy = (state) => {
  return getCventPrivacyPolicy(state).showCventPrivacyPolicy;
};

export const getCventPrivacyPolicyLinkText = (state) => {
  return getCventPrivacyPolicy(state).cventPrivacyPolicyLinkText || '';
};

export const getEventCompliancePolicy = (state) => {
  return getComplianceSettings(state).eventCompliancePolicy;
};

export const getShowCcpaSectionFlag = (state) => {
  return getEventCompliancePolicy(state).showCcpaSectionFlag;
};

export const getCcpaQualifyingQuestionFlag = (state) => {
  return getEventCompliancePolicy(state).ccpaQualifyingQuestionFlag;
};

export const getShowCcpaExternalSectionFlag = (state) => {
  return getEventCompliancePolicy(state).showCcpaExternalSectionFlag;
};

export const getCcpaLinkText = (state) => {
  return getEventCompliancePolicy(state).ccpaLinkText || '';
};

export const getCcpaExplanationText = (state) => {
  return getEventCompliancePolicy(state).ccpaExplanationText || '';
};

export const getCcpaButtonText = (state) => {
  return getEventCompliancePolicy(state).ccpaButtonText || '';
};

export const getCcpaConfirmationText = (state) => {
  return getEventCompliancePolicy(state).ccpaConfirmationText || '';
};

export const getCcpaInviteeValidationText = (state) => {
  return getEventCompliancePolicy(state).ccpaInviteeValidationText || '';
};

export const getCcpaQualifyingQuestionText = (state) => {
  return getEventCompliancePolicy(state).ccpaQualifyingQuestionText || '';
};

export const getCcpaQualifyingQuestionFailureText = (state) => {
  return getEventCompliancePolicy(state).ccpaQualifyingQuestionFailureText || '';
};

export const getCcpaExternalDoNotSellUrl = (state) => {
  return getEventCompliancePolicy(state).ccpaExternalDoNotSellUrl || '';
};

